// subscriptionTiers.js
// Maps each paid tier to which of featureFlagsContext.js's real flag keys it includes, plus
// display price and the Stripe test-mode Price ID BillingSettings.js sends to
// createBillingCheckoutSession. Purely a config object — editing prices/feature lists here
// never requires touching the gating logic itself (featureFlagsContext.js) or the Cloud
// Functions that read this same tier list server-side.
//
// A company with no subscriptionTier set at all is treated as fully unrestricted everywhere
// this is consulted (see featureFlagsContext.js) — this file only matters once a company has
// actually gone through the Billing tab and picked a plan.
export const SUBSCRIPTION_TIERS = {
  starter: {
    name: 'Starter',
    price: 99,
    stripePriceId: 'price_1U4JQTRZAWEySOIAH8tnDTCi',
    description: 'Core field service tools for solo technicians and small teams.',
    features: ['invoicing', 'communication', 'csvImport', 'gpsTracking']
  },
  professional: {
    name: 'Professional',
    price: 149,
    stripePriceId: 'price_1U4JQURZAWEySOIAEmx74lO6',
    description: 'Everything in Starter, plus email/sheet import and QuickBooks sync.',
    features: ['invoicing', 'communication', 'csvImport', 'gpsTracking', 'emailMonitoring', 'sheetsMonitoring', 'quickbooks']
  },
  premium: {
    name: 'Premium',
    price: 249,
    stripePriceId: 'price_1U4JQURZAWEySOIAJk7XExFw',
    description: 'Everything in Professional, plus multi-company and AI features.',
    features: ['invoicing', 'communication', 'csvImport', 'gpsTracking', 'emailMonitoring', 'sheetsMonitoring', 'quickbooks', 'multiCompany', 'aiCatalogImport', 'aiAssistant']
  }
};

export const TIER_ORDER = ['starter', 'professional', 'premium'];

// Human-readable labels for the feature flag keys above — BillingSettings.js's plan cards list
// these keys directly, and raw keys like 'gpsTracking' or 'aiCatalogImport' aren't fit to show
// a customer. Keep in sync with FEATURES' `name` fields in FeaturesPluginsSettings.js, which is
// the canonical description of each feature (this file only needs the short display name).
export const FEATURE_LABELS = {
  invoicing: 'Invoicing',
  communication: 'Communication',
  csvImport: 'Historical Work Order Import',
  gpsTracking: 'GPS Tracking',
  emailMonitoring: 'Email Monitoring',
  sheetsMonitoring: 'Google Sheet Monitoring',
  quickbooks: 'QuickBooks',
  multiCompany: 'Multi-Company Support',
  aiCatalogImport: 'AI Catalog Import (PDF)',
  aiAssistant: 'AI Drafting Assistant'
};

// Which tier(s) a given feature flag key first appears in — used by FeaturesPluginsSettings.js
// to tell an admin what to upgrade to, e.g. "Included in Premium".
export const getTierNameForFeature = (featureKey) => {
  const tierId = TIER_ORDER.find((id) => SUBSCRIPTION_TIERS[id].features.includes(featureKey));
  return tierId ? SUBSCRIPTION_TIERS[tierId].name : null;
};
